import { LookupModel } from '../../../../api/models';
import { CallStatus } from '../../../../core/enums/call-status.enum';
import { CallType } from '../../../../core/enums/call-type.enum';

export const EVENT_FILTER_SELECT_VALUES: Record<string, LookupModel[]> = {
  callStatus: Object.values(CallStatus).map(value => ({
    id: value,
    text: value,
  })),

  callType: Object.values(CallType).map(value => ({
    id: value,
    text: value,
  })),
};
